import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  useToast,
  useTheme,
} from "@chakra-ui/react";
import { Link as ReactLink, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function SimpleCard() {
  const toast = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()

  const theme = useTheme();
  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: new Yup.object({
      password: Yup.string().required("Please enter password"),
    }),
    onSubmit: (values, { setSubmitting }) => {
      const url = `${process.env.REACT_APP_API_URL}/client/auth/reset`;
      const id = searchParams.get("id")
      const token = searchParams.get("token")
      const password = values.password
      axios
        .post(url, {id, token, password})
        .then(({data}) => {
          toast({
            title: "Success",
            description: data.message,
            status: "success",
            position: "bottom-right",
          });
            navigate("/auth");
        })
        .catch((err) => {
          toast({
            title: "Error",
            description: err.response.data.error.message,
            status: "error",
            position: "bottom-right",
          });
          setSubmitting(false);
        });
    },
  });

  return (
    <Flex minH={"80vh"} align={"center"} justify={"center"}>
      <Stack spacing={8} mx={"auto"} w={["xs", "sm", "lg"]} py={12} px={6}>
        <Stack align={"center"}></Stack>
        <form onSubmit={formik.handleSubmit}>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"sm"}
            p={4}>
            <Heading
              fontSize={{ base: "lg", md: "xl" }}
              textAlign={"center"}
              pb={4}>
              Reset Password
            </Heading>
            <Stack spacing={4}>
              
              <FormControl
                isInvalid={!!formik.errors.password && formik.touched.password}>
                <FormLabel fontSize={"sm"}>New Password</FormLabel>
                <Input
                  type="password"
                  name="password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                  borderColor="slate.200"
                  _focus={{
                    borderColor: "brand.primary",
                    boxShadow: `0 0 0 1px ${theme.colors.brand.primary}`,
                  }}
                />

                <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
              </FormControl>
              <Stack spacing={10}>
                <Button
                  isLoading={formik.isSubmitting}
                  loadingText="Submitting"
                  type="submit"
                  variant={"solid"}
                  bg={"brand.primary"}
                  color="white"
                  _hover={(theme) => ({
                    background: theme.colors.brand.primaryDark,
                  })}
                  _active={(theme) => ({
                    background: theme.colors.brand.primaryDark,
                  })}>
                  Reset now
                </Button>
              </Stack>
              <Stack pt={6}>
                <Text align={"center"} fontSize={"sm"}>
                  New user?{" "}
                  <Link
                    color={"brand.primary"}
                    as={ReactLink}
                    to="/auth/signup">
                    Sign up
                  </Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </form>
      </Stack>
    </Flex>
  );
}
